import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import useDataApi from '../../hooks/useDataApi';
import { getDataUpTo } from '../../utils';
import WidgetBox from '../layout/WidgetBox/WidgetBox';
import { topStocksLong, topStocksShort } from './TopStocksColumns';
import List from '../list/List';
import { TopStocksIcon } from '../../styles/icons/icons';

const Dashboard = ({ data }) => (
	<WidgetBox header="Top Stocks">
		<div className="card-header">
			<h3 className="card-title">
				<TopStocksIcon /> Top Stocks
			</h3>
		</div>
		<List
			newData={getDataUpTo(3, data)}
			columns={topStocksShort}
			isPagination={false}
			tableClass="sidebar-widget"
		/>
		<div className="text-right">
			<NavLink to="/topstocks" className="link-text">
				&gt; View More
			</NavLink>
		</div>
	</WidgetBox>
);

const Page = ({ data }) => {
	return (
		<>
			<List newData={data} columns={topStocksLong()} />
		</>
	);
};

const ViewSelector = ({ data, type }) =>
	type === 'short' ? <Dashboard data={data} /> : <Page data={data} />;

const View = ({ data, isLoading, isError, type = 'short' }) => (
	<>
		{isError && <div>Something went wrong</div>}
		{isLoading ? <div>Loading...</div> : <ViewSelector data={data} type={type} />}
	</>
);

const TopStocks = (props) => {
	const url = `/topstocks?hash=${props.refreshPage}`;
	const [dataProps, setUrl] = useDataApi(url, [], { method: 'POST' });

	useEffect(() => {
		setUrl(url);
	}, [props.refreshPage]);

	return <View {...props} {...dataProps} />;
};

export default TopStocks;
